/**
 * Opções de Permissões e Acessos do Sistema
 *
 * Este arquivo centraliza todas as opções de permissões e acessos
 * utilizadas em diferentes partes do sistema para evitar duplicação
 * e facilitar manutenção.
 */

export const PERMISSIONS_OPTIONS = [
  { name: 'Movimentação de Associados', value: 'MOVIMENTACAO' },
  { name: 'Visualização de Associados', value: 'VISUALIZACAO_ASSOCIADOS' },
  { name: 'Visualização de Cards', value: 'VISUALIZACAO_CARD' },
  { name: 'Visualização de Eventos', value: 'VISUALIZACAO_EVENTOS' },
  { name: 'Importação de Cards', value: 'IMPORTACAO_CARDS' },
  { name: 'Criar/editar campanhas', value: 'ACESSO_CAMPANHA' },
  { name: 'Acesso Relatórios', value: 'ACESSO_RELATORIOS' },
  { name: 'Operador de atendimento PA', value: 'OPERADOR_ATENDIMENTO' },
  { name: 'Operador de atendimento geral', value: 'OPERADOR_ATENDIMENTO_GERAL' },
  { name: 'Gestor de Atendimento', value: 'GESTOR_ATENDIMENTO' },
  { name: 'Criar/editar Oportunidades Ajuizamento', value: 'ACESSO_AJUIZAMENTO' },
  { name: 'Visualizar renda e movimentação de funcionários', value: 'VISUALIZACAO_INFOS_PRIVADAS_ASSOCIADOS' },
  { name: 'Desbloquear Ajuizamento', value: 'DESBLOQUEAR_AJUIZAMENTO' },
  { name: 'Alterar Responsável', value: 'ALTERAR_RESPONSAVEL' },
  { name: 'Administrador', value: 'ADMINISTRADOR' },
  { name: 'Criar Usuário', value: 'CRIAR_USUARIO' },
  { name: 'Importação Planilha', value: 'IMPORTACAO_PLANILHA' }
]

export const ACCESS_OPTIONS = [
  { name: 'Vendas', value: 'VENDA' },
  { name: 'Operações', value: 'OPERACAO' },
  { name: 'Cobranças', value: 'COBRANCA' },
  { name: 'Ajuizamento', value: 'AJUIZAMENTO' }
]

/**
 * Retorna as opções de permissões formatadas para uso em v-select
 * @returns {Array} Array de objetos com propriedades name e value
 */
export const getPermissionsOptions = () => {
  return PERMISSIONS_OPTIONS
}

/**
 * Retorna as opções de acessos formatadas para uso em v-select
 * @returns {Array} Array de objetos com propriedades name e value
 */
export const getAccessOptions = () => {
  return ACCESS_OPTIONS
}

/**
 * Busca uma permissão pelo seu valor
 * @param {string} value - Valor da permissão (ex: 'ADMINISTRADOR')
 * @returns {Object|null} Objeto da permissão ou null se não encontrada
 */
export const getPermissionByValue = (value) => {
  return PERMISSIONS_OPTIONS.find(permission => permission.value === value) || null
}

/**
 * Busca um acesso pelo seu valor
 * @param {string} value - Valor do acesso (ex: 'VENDA')
 * @returns {Object|null} Objeto do acesso ou null se não encontrado
 */
export const getAccessByValue = (value) => {
  return ACCESS_OPTIONS.find(access => access.value === value) || null
}



// WEBPACK FOOTER //
// ./src/shared/constants/permissionsAndAccessOptions.js